import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TabContainer = styled.div<{ $showFade?: boolean }>`
  display: flex;
  flex-direction: row;
  ${(props) => props.theme.container};
  padding: 4px;
  overflow-x: auto;
  scrollbar-width: none;
  transition: mask-image 0.25s ease, -webkit-mask-image 0.25s ease;

  -webkit-mask-image: ${(props) =>
    props.$showFade
      ? 'linear-gradient(to right, black calc(100% - 4rem), transparent 100%)'
      : 'none'};
  mask-image: ${(props) =>
    props.$showFade
      ? 'linear-gradient(to right, black calc(100% - 4rem), transparent 100%)'
      : 'none'};

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Tab = styled.div<{ active: boolean; textContent: string; fullWidth?: boolean }>`
  position: relative;
  box-sizing: border-box;
  ${(props) => (props.fullWidth ? 'flex: 1 1 0; min-width: 0;' : 'flex-shrink: 0;')}
  cursor: pointer;
  padding: 9px 14px;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${(props) => (props.active ? tokens.accent.base : 'transparent')};
  background-color: ${(props) => (props.active ? tokens.accent.soft : 'transparent')};
  color: transparent;
  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    ${(props) => !props.active && `background-color: ${tokens.surface.inset};`}
  }

  ::after {
    content: '${(props) => props.textContent}';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    font-size: 0.9rem;
    font-weight: ${(props) => (props.active ? '500' : '400')};
    color: ${(props) => (props.active ? tokens.accent.base : tokens.text.secondary)};
  }

  &:hover::after {
    ${(props) => !props.active && `color: ${tokens.text.primary};`}
  }
`

export const SecondaryTab = styled.div<{ active: boolean; textContent: string }>`
  position: relative;
  width: 100%;
  cursor: pointer;
  padding: 10px 12px;
  background-color: ${(props) => (props.active ? tokens.accent.soft : 'transparent')};
  color: ${(props) => (props.active ? tokens.accent.base : tokens.text.secondary)};
  border-bottom: 1px solid
    ${(props) => (props.active ? tokens.accent.base : tokens.border.hairline)};
  text-align: center;

  &:first-child {
    border-top-left-radius: 12px;
  }
  &:last-child {
    border-top-right-radius: 12px;
  }
`

export const SectionTabContainer = styled.div`
  display: flex;
  flex-direction: row;
`
